<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<app-footer></app-footer>

<!-- body -->
@if (!loading) {
<div class="content-page bg-gray">
    <!-- <div class="content p-1 text-dark"> -->
    <div class="d-flex align-items-center m-0 p-1">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb m-0 p-0">
                @if (!fixedRole) {
                <li class="breadcrumb-item"><a [routerLink]="['/' + path]">Contacts</a></li>
                }
                @if (fixedRole) {
                <li class="breadcrumb-item"><a [routerLink]="['/settings/' + path]">{{fixedRoleName}}</a></li>
                }
                <li class="breadcrumb-item active" aria-current="page">{{ words[language][ 'detail' ] }}
                </li>
            </ol>
        </nav>
    </div>

    @if (contactId > 0) {
        <section class="sticky-toolbar rounded">
            <div class="card">
                <div title="View Notes">
                    <notes [module]="'contacts'" [contactId]="contactId" title="View Notes" (notes$)="listenerChildrens($event)"></notes>
                </div>
                <div class="sticky shadow rounded">
                    <div type="button" class="btn btn-light btn-sm w-100 p-1 text-left" title="View Activity Log" [routerLink]="['/activity']"><span class="uil-history-alt"></span></div>
                </div>
            </div>
        </section>
    }
    
    <general-information class="col-md-12" [contactId]="contactId" (generalInformation$)="listenerChildrens($event)"></general-information>

    @if (isEmployee) {
        <employee-commission-setup class="col-md-12" [contactId]="contactId" [isFlat]="false"></employee-commission-setup>
    }
    <div class="row">
        @if (!fixedRole) {
            <div class="col-md-9">
                <contact-roles [contactId]="contactId"></contact-roles>
            </div>
        }
        <div class="col">
            <addresses [contactId]="contactId" [isFlat]="false" [isIndividual]="isIndividual"></addresses>
            <communications [contactId]="contactId" [isFlat]="false"></communications>
        </div>
    </div>
    @if (contact !== null) {
    <div class="p-3">
        @if (contact && contact.createdByUser) {
            <p class="text-dark m-0 p-0">
                <span class="font-weight-bold">{{ words[language][ 'createdBy' ] }}: </span>
                {{contact.createdByUser.firstName + ' ' + contact.createdByUser.lastName}}
            </p>
        }
        @if (contact && contact.createdByUser) {
            <p class="text-dark m-0 p-0">
                <span class="font-weight-bold">{{ words[language][ 'dateCreated' ] }}:</span>
                {{contact && contact.createdAt ? (contact.createdAt | date:'short') : ''}}
            </p>
        }
        @if (contact && contact.modifiedByUser) {
            <p class="text-dark m-0 p-0">
                <span class="font-weight-bold">{{ words[language][ 'modifiedBy' ] }}:</span>
                {{contact.modifiedByUser.firstName + ' ' + contact.modifiedByUser.lastName}}
            </p>
        }
        @if (contact && contact.modifiedByUser) {
            <p class="text-dark m-0 p-0">
                <span class="font-weight-bold">{{ words[language][ 'dateModified' ] }}:</span>
                {{contact && contact.updatedAt ? (contact.updatedAt | date:'short') : ''}}
            </p>
        }
    </div>
    }
    <!-- </div> -->
</div>
}
@else {
    <div class="content-page bg-gray d-flex justify-content-center align-items-center">
        <div class="spinner-grow avatar-lg text-secondary" role="status"></div>
    </div>
}